/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartPieEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 2h1c4.76 0 8.742 3.325 9.752 7.779L22.03 11H11zm2 2.062V9h6.419A8.01 8.01 0 0 0 13 4.062zm-4.555.77a8.004 8.004 0 0 0 1.776 14.97l-.442 1.95C5.325 20.742 2 16.76 2 12a10 10 0 0 1 5.555-8.96zm8.848 7.46a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.415L16.414 22H12v-4.414zM14 18.415V20h1.586l4-4L18 14.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartPieEdit as ChartPieEdit };
